module.exports = __webpack_public_path__ + "img/marker-truck-red.401ac912.svg";